import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-simple-dialog',
    templateUrl: './simple-dialog.component.html',
    styleUrls: ['./simple-dialog.component.scss'],
    imports: [MatIconButton, MatDialogClose, MatIcon, MatDialogTitle, MatDialogActions, MatButton]
})
export class SimpleDialogComponent {
  data = inject<{
    title: string;
    message: string;
  }>(MAT_DIALOG_DATA);
}
